import React from 'react'
import {
  Button,
  FormDashboardLabel as Label,
  TagAdder,
  ButtonOutline,
  // VisibilitySelector,
  AudienceSelect,
  ImageDropzone,
} from '../../../components'
import { /* Link,  */useHistory } from 'react-router-dom'
import { TagProvider } from '../../../features/tag/hook/provider'
import { SystemProvider } from '../../../features/system/provider'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'
import { updateForm } from '../../../features/blog-form/slice'
import { SidebarApproach } from './sidebar-approach'
import { SidebarIssue } from './sidebar-issue'
import SidebarCategories from './sidebar-categories'
import service from '../../../features/blog/service'
import { toast } from 'react-toastify'
import { SidebarStatus } from './sidebar-status'
import { submissionStatus } from '../../../constants'
import { useInternationalization } from '../../../features/i18n'

const Sidebar = ({ requesting, isEdit, handleSubmit }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const form = useSelector(state => state.blogForm.data)
  const { id } = useSelector(state => state.blog.data)
  const {
    suitable,
    tags,
    thumbnail,
  } = form
  const { translate } = useInternationalization()

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const handleImage = (e) => {
    if (e && e.length > 0) {
      const file = e[0]
      const name = file.name
      const type = file.type
      const blob = URL.createObjectURL(file)
      const imageWithBlob = {name, type, blob}

      if(blob && blob !== null && blob !== 'null'){
        dispatch(updateForm({
          key: 'thumbnail',
          value: imageWithBlob
        }))
      } else {
        removeImage()
      }
    } else {
      removeImage()
    }

    function removeImage(){
      dispatch(updateForm({
        key: 'thumbnail',
        value: undefined
      }))
    }
  }

  const handleDelete = () => {
    let c = window.confirm(translate('GENERAL', 'delete_confirm'))
    if(c){
      service.delete(id)
        .then(res => {
          console.log(res)
          toast.success('Blog successfully deleted!')
          history.push('/dashboard/blog')
        })
        .catch(err => {
          console.log(err)
          toast.error('Error.')
        })
    }
  }

  const handleDraft = (e) => {
    e.preventDefault()
    e.stopPropagation()

    handleSubmit({submission: submissionStatus.draft})
  }

  return (
    <div>
      <div className="hidden lg:block p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
        <SidebarStatus isEdit={isEdit}/>

        <Button
          className="mb-3"
          disabled={requesting}
          isLoading={requesting}
        >
          {translate('GENERAL', 'submit')}
        </Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent py-4"
          disabled={requesting}
          isLoading={requesting}
          onClick={handleDraft}
        >
          {translate('GENERAL', 'save_to_draft')}
        </ButtonOutline>

        {
          isEdit && <>
            {/* <Link className="block link text-sm pt-4" to={`/blog/${id}/detail`}>
              View Blog
            </Link> */}

            <div
              className="mt-5 text-center text-xs text-gray-500 underline cursor-pointer"
              onClick={handleDelete}
            >
              {translate('GENERAL', 'delete')}
            </div>
          </>
        }
      </div>

      <div className="mb-5 lg:mb-10">
        <ImageDropzone
          label={translate('GENERAL', 'thumbnail_image')}
          defaultValue={thumbnail?.blob}
          onChange={handleImage}
        />
      </div>

      <div className="mb-5 lg:mb-10">
        <SidebarCategories />
      </div>

      {/* <div className="mb-5 lg:mb-10">
        <div className="mb-5 lg:mb-0">
          <Label>Visibility</Label>
        </div>
        <VisibilitySelector
          form={form}
          updateForm={updateForm}
        />
      </div> */}

      <SystemProvider>
        <div className="mb-5 lg:mb-10">
          <AudienceSelect
            defaultValues={suitable}
            updateForm={handleInput}
          />
        </div>

        <div className="mb-5 lg:mb-10">
          <SidebarApproach />
        </div>

        <div className="mb-5 lg:mb-10">
          <SidebarIssue />
        </div>
      </SystemProvider>

      <TagProvider>
        <div className="mb-8 lg:mb-10">
          <Label>Tag</Label>
          <TagAdder
            data={tags}
            onChange={(value) => {
              handleInput({
                target: {
                  name: 'tags',
                  value
                }
              })
            }}
          />
        </div>
      </TagProvider>

      <div className="lg:hidden mb-10">
        <Button thin className="mb-3" onClick={() => history.push('/dashboard/blog')}>
          {translate('GENERAL', 'submit')}
        </Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent"
          onClick={() => history.push('/dashboard/blog')}
        >
          {translate('GENERAL', 'save_to_draft')}
        </ButtonOutline>
      </div>
    </div>
  )
}

export { Sidebar }
